import React from 'react';
import { Spinner } from '@/components/ui/spinner';
import { Col, ListGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DuringBreak } from '../../../hooks/useCurrentTimeTrackingTimeline';
import { useBreakTypes } from '../../../hooks/timeTracking/useBreakTypes';
import { getBreakTypeName } from '../../../components/BreakTypeIcon';
import { roundSmCircleIconButtonStyle } from '../../../components/roundSmCircleIconButtonStyle';
import ResumeTimeTrackingButton from './ResumeTimeTrackingButton';
import TimeUntilNow from './TimeUntilNow';

type Props = {
  step: DuringBreak;
};

const DuringBreakStep: React.FC<React.PropsWithChildren<Props>> = ({
  step,
}) => {
  const { timeEntryId } = step;
  const { t } = useTranslation();
  const breakTypes = useBreakTypes();
  const breakTypeName = getBreakTypeName(breakTypes, step.breakTypeId);

  return (
    <ListGroup.Item>
      <Row className="align-items-center">
        <Col className="col-auto">
          <div className="avatar avatar-sm">
            <div className="avatar-title fs-3 bg-primary-soft rounded-circle text-primary">
              <Spinner animation="grow" variant="warning" />
            </div>
          </div>
        </Col>
        <Col className="ms-n2 align-self-center">
          <h4 className="mb-1">
            <TimeUntilNow date={step.startTime} />
          </h4>
          <small className="text-dark">
            {breakTypeName
              ? t('timeTracking.current.steps.duringBreak.breakTimeWithType', {
                  type: breakTypeName,
                })
              : t('timeTracking.current.steps.duringBreak.breakTime')}
          </small>
        </Col>
        <Col className="col-auto align-self-center">
          <ResumeTimeTrackingButton
            className="lift d-inline-flex align-items-center justify-content-center"
            style={roundSmCircleIconButtonStyle}
            timeEntryId={timeEntryId}
          />
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

export default DuringBreakStep;
